import React from 'react';

const TitleHeader = () => {
  return (
    <div className="text-4xl mb-2 normal-text-glow font-extrabold text-center cursor-default">
      AI and Human Art Classifier
    </div>
  );
}

export default TitleHeader;
